import PropTypes from 'prop-types';

var date = PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]);

export default {
  date: date
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/src/constants/prop-types.js
// module id = 101
// module chunks = 0